import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Button,  Label,  Container, Spinner, Modal, ModalHeader, ModalBody,Table } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { Link } from "react-router-dom";
import axios from "axios";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"
import { isEmpty } from "lodash";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class EditPricing extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 4, 'edit' )){
      this.props.history.push('/activities')
    }
    this.state = {
      loading: false,
      loadingstate: false,
      grouploading:false,
      editgrouploading:false,
      model_type:false,
      model_edit_group:false,

      alert_confirm : false,
      success_confirm : false,
      dynamic_title: "",
	  dynamic_description: "",
      group_id:"",
      edit_group:{},

      pricing:[],

      selectedGroup:false,
      TypeGroup:[],


      breadcrumbItems: [ ],
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
	

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGroupPriceSubmit = this.handleGroupPriceSubmit.bind(this)
    this.handleEditGroupPriceSubmit = this.handleEditGroupPriceSubmit.bind(this)
    this.handleselectedGroup = this.handleselectedGroup.bind(this);
    this.addGroupPrice = this.addGroupPrice.bind(this)
    this.handleEditGroupPrice = this.handleEditGroupPrice.bind(this)
    this.tog_type = this.tog_type.bind(this);
    this.tog_AddPersonsGroup = this.tog_AddPersonsGroup.bind(this)
    this.handleAddGroupSubmit = this.handleAddGroupSubmit.bind(this)

  }


  tog_type() {
    this.setState(prevState => ({
      model_type: !prevState.model_type
    }));
    this.removeBodyCss();
  }
  tog_edit_group() {
    this.setState(prevState => ({
        model_edit_group: !prevState.model_edit_group
    }));
    this.removeBodyCss();
  }
  
    tog_AddPersonsGroup() {
    this.setState(prevState => ({
        model_AddGroupPrice: !prevState.model_AddGroupPrice
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  addGroupPrice(){
    this.loadGroupsData()
    this.tog_type()
    

  }


  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/activities')
  }

  async componentDidMount() {
      this.loadData()
    
 }
 async loadData(){
    const id =this.props.match.params.id
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      };
      await fetch(`${BaseUrl}/api/activities/pricing/${id}/`,requestOptions)
          .then(res => res.json())
          .then(
              (data) => {
                let breadcrumbItems = [
                    { title: "Activity Detail", link: `/activity/${data.activity}` },
                    { title: "Edit Activity Pricing", link: "#" },
                  ]
                  
                this.setState({ pricing:data,breadcrumbItems:breadcrumbItems})       
              },
              (error) => {
                this.props.history.push(`/activities`)
              }
          )  
 }

async loadGroupsData(){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/activities/persons_group/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                const {pricing} = this.state
                let options = []
                let added_group = []
                for(let i=0; i<pricing.group_pricing.length ; i++){
                    added_group.push(pricing.group_pricing[i].group.id)   
                }

                data.map(group => {
                    if(!added_group.includes(group.id)){
                        let lable = group.max_person ===1?`Per Person`:`${group.min_person} - ${group.max_person} Person`
                        options.push({ label: lable, value: group.id })
                    }
                })
              
                let TypeGroup = [
                  { 
                    label: "TypeGroup",
                    options: options
                  }
                ];
                this.setState({ TypeGroup: TypeGroup,
                })           
                
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }

  async loadActivityData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/activities/persons_group/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              
              this.setState({ activity: data })           
              
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
  }

  handleselectedGroup = selectedGroup => {
    this.setState({ selectedGroup  })
  };
  handleEditGroupPrice(item) {
      this.setState({ edit_group:item })
      this.tog_edit_group()

  }

  handleAddGroupSubmit(e, values){
    this.setState({ grouploading: true })
    axios.post(
      `${BaseUrl}/api/activities/persons_group/`,
      values,
      {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                   
      }
    ).then(res => {
      toastr.success(`Group ${res.min_person} - ${res.max_person} Added`,"") 
      this.loadGroupsData()
      this.setState({model_type:false, grouploading:false })
  
    }).catch(err => {
      console.log(err, "----------------------error");
      })
  }


  handleEditGroupPriceSubmit(e, values){
    this.setState({ editgrouploading:true })
      const {edit_group} = this.state
      let data = {}
      data['price'] = values.price
      data['on_season_price'] = values.on_season_price
      data['activity'] = edit_group.activity
      data['group'] = edit_group.group.id
      axios.put(
        `${BaseUrl}/api/activities/group_pricing/${edit_group.id}/`,
        data,
            {
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                   
            }
        )
        .then(res => {
          let lable = res.data.group.max_person ===1?`Per Person`:`${res.data.group.min_person} - ${res.data.group.max_person} Person`
            toastr.success(`${lable} Price Updated`,"")
            this.setState({ editgrouploading:false, model_edit_group:false, edit_group:{}})
            this.loadData()
        })
        .catch(err => {
            toastr.error(`Somthing Went Wrong`,"") 
            this.setState({ editgrouploading:false, model_edit_group:false, edit_group:{}})
            
        })
  }

  handleGroupPriceSubmit(e, values){
    this.setState({ grouploading: true })
    const {pricing, selectedGroup} = this.state
    if (selectedGroup){
        let data = {}
        data['price'] = values.group_price
        data['on_season_price'] = values.on_season_price
        data['activity'] = pricing.activity
        data['group'] = selectedGroup.value
    axios.post(
        `${BaseUrl}/api/activities/group_pricing/`,
        data,
        {
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                    
        }
    ).then(res => {
            let added_group = []
            for(let i=0; i<pricing.group_pricing.length ; i++){
                added_group.push(pricing.group_pricing[i].id)   
            }
            added_group.push(res.data.id)
            let pricing_data = {}
            pricing_data['activity'] = pricing.activity
            pricing_data['distance'] = pricing.distance
            pricing_data['duration'] = pricing.duration
            pricing_data['per_persion'] = pricing.per_persion
            pricing_data['group_pricing'] = added_group

            axios.put(
            `${BaseUrl}/api/activities/pricing/${pricing.id}/`,
                pricing_data,
                {
                  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                  
                }
            )
            .then(priceres => {
              
                let lable = res.data.group.max_person ===1?`Per Person`:`${res.data.group.min_person} - ${res.data.group.max_person} Person`
                toastr.success(`${lable} Price Added`,"")
                this.setState({ selectedGroup:false, model_type:false, grouploading:false })
                this.loadData()
            })
            .catch(err => {
                toastr.error(`Somthing Went Wrong`,"") 
                this.setState({ selectedGroup:false, model_type:false, grouploading:false })
                
            })

    }).catch(err => {
        this.setState({ selectedGroup:false, model_type:false, grouploading:false })
        
        })

    }else{
        toastr.error(`Select Group`,"") 
        this.setState({ grouploading: false, })
    }

  }

  handleDeleteGroupPrice= id =>{
      const requestOptions = {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${this.obj.access}` },
      };
      fetch(`${BaseUrl}/api/activities/group_pricing/${id}/`,requestOptions)
          .then(res => 
              {if(res.status >= 400){
                  console.log("error")
                  this.setState({
                  group_id:"",
                  success_confirm: false,
                  alert_confirm : false,
                  dynamic_title: "",
                  dynamic_description: ""
                  })
              }
              else{
                  this.loadData();
                  this.setState({
                  group_id:"",
                  success_confirm: true,
                  alert_confirm : false,
                  dynamic_title: "Deleted!",
                  dynamic_description: "Group Price has Been Deleted"
                  })
                  this.loadData()
              }
          }
      )
  }



  handleSubmit(e, values) {
      this.setState({ loading: true })
      const {pricing} = this.state
      let added_group = []
          for(let i=0; i<pricing.group_pricing.length ; i++){
              added_group.push(pricing.group_pricing[i].id)   
          }
          let pricing_data = {}
          pricing_data['activity'] = pricing.activity
          pricing_data['distance'] = values.distance
          pricing_data['duration'] = values.duration
          pricing_data['group_pricing'] = added_group

          axios.put(
          `${BaseUrl}/api/activities/pricing/${pricing.id}/`,
              pricing_data,
              {
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                 
              }
          )
          .then(res => {
              
              this.props.history.push(`/activity/${pricing.activity}`)
          })
          .catch(err => {
              toastr.error(`Somthing Went Wrong`,"") 
              this.setState({ loading:false,})
              
          })
      

  }

  render() {
    const { TypeGroup, pricing, edit_group } = this.state
    const PersonsGroups = ({ innerRef, innerProps, isDisabled, children }) =>
    !isDisabled ? (
        <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
            {children}
            <Link to="#" onClick={this.tog_AddPersonsGroup}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
        </div>
    ) : null;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Edit Pricing" breadcrumbItems={this.state.breadcrumbItems} />
            {!isEmpty(pricing) ? (
            <AvForm className="needs-validation" enctype="multipart/form-data" onValidSubmit={this.handleSubmit} >
            <Row>
              <Col xl="6">
                <Card>
                  <CardBody> 
                    <h4 className="card-title">Activity Pricing</h4>

                        <Row>  
                          <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label " htmlFor="distance">Distance</Label>
                                  <AvField
                                  name="distance"
                                  placeholder="Distance"
                                  type="text"
                                  value={pricing.distance}
                                  errorMessage="Enter Distance"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="distance"
                                  
                                  />
                              </div>
                          </Col> 
                          <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label " htmlFor="duration">Time Duration</Label>
                                  <AvField
                                  name="duration"
                                  placeholder="Duration"
                                  type="text"
                                  value={pricing.duration}
                                  errorMessage="Enter Duration"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="duration"
                                  
                                  />
                              </div>
                          </Col> 
                        </Row> 
                        <Row>
                        <div className="table-responsive">
                            <Table className="table-nowrap mb-0">
                                <tbody>
                                    <tr key={'PricingHeading'}>
                                        <th
                                        scope="row"
                                        >
                                        {"Group"}
                                        </th>
                                        <th
                                        scope="row"
                                        >
                                        {"Off Season Price"}
                                        </th>
                                        <th
                                        scope="row"
                                        >
                                        {"On Season Price"}
                                        </th>
                                        <th
                                        scope="row"
                                        >
                                        {"Action"}
                                        </th>
                                    </tr>
                                 
                                    {pricing.group_pricing.map((group_price) => {
                                        return(
                                            <tr key={group_price.id}>

                                                <td>{group_price.group.max_person ===1?`Per Person`:`${group_price.group.min_person} - ${group_price.group.max_person} Person`}</td>
                                                <td>₹ {group_price.price}</td>
                                                <td>₹ {group_price.on_season_price}</td>
                                                <td>
                                                <Link to="#" onClick={() => this.handleEditGroupPrice(group_price)}  className="text-primary"><i className="mdi mdi-pencil-outline font-size-18"></i></Link>{" "}
                                                <Link to="#" onClick={() => this.setState({ alert_confirm: true, group_id:group_price.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                                </td>
                                            </tr>

                                        )
                                    })}
                                    </tbody>
                                  </Table>
                                </div>    
                        </Row>  

                      
                        <Button className="btn-sm mt-2" type="button" onClick={() => this.addGroupPrice()} color="info"><i className=" fas fa-plus"></i></Button>
                        {" "}             
                      <FormGroup className="mb-1 mt-3">
                        {this.state.loading?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                          <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                      </Button>{" "}
                      
                      </div>
                        )}
                      
                      
                    </FormGroup>      

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </AvForm>
               
            ):
            <div className="d-flex align-items-center justify-content-center min-vh-100">
            
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
      
            </div>
                  }
            {/* Add Group Price */}
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_type}
                 toggle={this.tog_type}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_type: false })}>
                 Add Group Price
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleGroupPriceSubmit} >
           
                   <Row>
                        <Col md="12">
                            <div className="mb-3">
                                <Label className="form-label">Group</Label>
                                <Select 
                                onChange={this.handleselectedGroup}
                                options={TypeGroup}
                                components={{ Menu: PersonsGroups }}
                                classNamePrefix="select2-selection"
                                />

                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <div className="mb-3">
                            <Label className="form-label " htmlFor="group_price">Off Season Price</Label>
                            <AvField
                                name="group_price"
                                placeholder="Off Season Price"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                required: { value: true },
                                }}
                                id="group_price"
                            />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <div className="mb-3">
                            <Label className="form-label " htmlFor="group_on_season_price">On Season Price</Label>
                            <AvField
                                name="on_season_price"
                                placeholder="On Season Price"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                required: { value: true },
                                }}
                                id="group_on_season_price"
                            />
                            </div>
                        </Col>
                    </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.grouploading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
             {/* Edit Group Price */}
             <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_edit_group}
                 toggle={this.tog_edit_group}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_edit_group: false })}>
                 Edit {edit_group.group?edit_group.group.name:""} Price
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleEditGroupPriceSubmit} >
           
                   <Row>
                        
                        <Col md="12">
                            <div className="mb-3">
                            <Label className="form-label" htmlFor="group_price">Off Season Price</Label>
                            <AvField
                                name="price"
                                placeholder="Price"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                value={parseInt(edit_group.price)}
                                validate={{
                                required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="group_price"
                            />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        
                        <Col md="12">
                            <div className="mb-3">
                            <Label className="form-label" htmlFor="on_season_price">On Season Price</Label>
                            <AvField
                                name="on_season_price"
                                placeholder="Price"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                value={parseInt(edit_group.on_season_price)}
                                validate={{
                                required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="on_season_price"
                            />
                            </div>
                        </Col>
                    </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.editgrouploading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
              {/* Add Group */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_AddGroupPrice}
                 toggle={this.tog_AddPersonsGroup}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_AddGroupPrice: false })}>
                 Add Group
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddGroupSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="min_person">Min</Label>
                           <AvField
                              name="min_person"
                              placeholder="Minimum Person"
                              type="number"
                              className="form-control"
                              errorMessage="Enter Only Number"
                              validate={{
                              required: { value: true },
                                  pattern: {
                                  value: "^[0-9]+$",
                                  errorMessage: "Only Numbers"
                                  }
                              }}
                              id="min_person"
                          />
                         </div>
                       </Col> 
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="max_person"> Max</Label>
                           <AvField
                              name="max_person"
                              placeholder="Maximum Person"
                              type="number"
                              className="form-control"
                              errorMessage="Enter Only Number"
                              validate={{
                              required: { value: true },
                                  pattern: {
                                  value: "^[0-9]+$",
                                  errorMessage: "Only Numbers"
                                  }
                              }}
                              id="max_person"
                          />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.grouploading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
            </Col>

            </Container>
            {this.state.alert_confirm ? (
            <SweetAlert
            title="Are you sure?"
            warning
            showCancel
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={() => this.handleDeleteGroupPrice(this.state.group_id)}
            onCancel={() =>
                this.setState({
                    alert_confirm: false,
                    group_id:"",

                })
            }
            >
            You won't be able to revert this!
            </SweetAlert>
            ) : null}

            {this.state.success_confirm ? (
                <SweetAlert
                success
                title={this.state.dynamic_title}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                >
                    {this.state.dynamic_description}
                </SweetAlert>
            )
            : null}
        </div>
      </React.Fragment>
    );
  }
}

export default EditPricing;
